export default __webpack_public_path__ + "static/media/img_3.e9e9fe14.svg";